<template>
  <div class="height44px size23 line44 fixed l t r zIndex9 flex between head" :style="style"
    :class="{BGwhite:$route.path!='/',Cfff:$route.path=='/'}">
    <van-icon name="arrow-left" class="ml10" @click="back " />
    <div class="a355 size18 weight" style="margin-left:14%">
      <slot />
    </div>
    <div class="flex mr20">
      <van-icon name="arrow" @click="$emit('next')" :color="isForward || next? '':'rgb(0,0,0,.1)'" />
      <!-- <van-icon name="ellipsis" class="ml20" v-if="more" @click="lookmore" /> -->
      <img src="@/assets/img/icon-more.png" class="width30px pad4 pointer ml10" v-if="more" @click="lookmore" alt="">
    </div>
  </div>
  <div class="fixed r b b300 width25 line35 size14 scroll animated fadeIn" @click="showRight=false" :style="{
    zIndex: 9999999,
    display:showRight?'block':'none',
    background: $route.path=='/'?'linear-gradient(to right,rgba(50,50,50,0),rgba(50,50,50,0) 65%,rgba(50,50,50,.8) 65%)':'linear-gradient(to right,rgba(200,200,200,.3),rgba(200,200,200,.6) 65%,white 65%)',
    color:$route.path=='/'?'rgba(255,255,255,.8)':'#333'
  }" style="height:calc(100% - 44px);padding-top:0;width:100%;padding-left:65%;box-shadow:-10px 0 20px rgba(50,50,50,.1);">
    <div v-for="item,index in list" :key="index" style="text-align:center"
      :class="item.path.split('/')[1]==$route.path.split('/')[1]?'BGon Cfff line3':''" @click.stop="toPath(item)">
      <span class="relative">{{item.title}}<i class="reddot" v-if="item.hasMsg && hasMsg === 1"></i></span>
    </div>
  </div>
  <!-- <van-popup
    v-model:show="showRight"
    position="right"
    class="homePopup b300 size14"
    :style="{ width: '30%', height: '100%' }"
  >
    <div v-for="item,index in list" :key="index" class="btn" 
    :class="item.path.split('/')[1]==$route.path.split('/')[1] || (item.path=='/' && ($route.path.split('/')[1] == 'culture' || $route.path=='/') )?'BGon Cfff line3':''" @click="item.path && $router.push({path:item.path})">
      {{item.title}}
    </div>
  </van-popup> -->
</template>

<script>
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'Home',
  data () {
    return {
      showRight: false,
      list: [
        { title: "回到首页", path: '/' },
        { title: "雾森文明", path: '/culture' },
        { title: "雾森商城", path: '/shop' },
        { title: "雾森法治", path: '/vote', clear: true },
        { title: "雾森财政", path: '/money' },
        { title: "雾森招聘", path: '/recruit' },
        { title: "雾森加盟", path: '/join' },
        { title: "雾森论文", path: '/paper' },
        { title: "雾森采购", path: '/procure' },
        { title: "雾森论坛", path: '/forum', clear: true },
        { title: "我的主页", path: '/me', hasMsg: true, clear: true },
        { title: "关于我们", path: '/aboutus' },
      ],
      path: "",
      metaTitle: "",
      isForward: false
    }
  },
  computed: mapState([
    'hasMsg'
  ]),
  methods: {
    ...mapMutations([
      'setShowRight', // 将 `this.increment()` 映射为 `this.$store.commit('increment')`
    ]),
    toPath (item) {
      if (item.path) {
        this.showRight = false;
        this.$router.push({ path: item.path })
        if (item.clear) {
          // setTimeout(()=>{
          //   this.$store.state.key++ // 个别组件数据刷新下
          // },1)
        }
      }
    },
    back () {
      this.$router.back()
      // if(this.$route.meta.toHome) {
      //   this.$router.push({path:"/"})
      // } else {
      //   this.$router.back()
      // }
    },

    lookmore () {
      this.showRight = !this.showRight;
      this.$emit('more');
      this.$store.commit('setShowRight', this.showRight)
    }

  },
  props: {
    backfn: { type: Boolean, default: false },
    next: { type: Boolean, default: false },
    more: { type: Boolean, default: true },
    style: { type: String, default: '' }
  },
  watch: {
  },
  mounted () {
    // console.log(history)
    if (history.state.forward !== null && history.state.forward !== "") {
      this.isForward = true
    } else {
      this.isForward = false
    }
  }
}
</script>
<style>
.reddot {
  position: absolute;
  width: 7px;
  height: 7px;
  top: 0;
  right: -4px;
  background-color: red;
  border-radius: 50%;
}
</style>